import React, {Component, useCallback} from 'react';
import toastr from "toastr";
import Stepper from 'react-stepper-horizontal'
import {useDropzone} from 'react-dropzone';
import Dropzone from 'react-dropzone';
import csv from 'csv';
import http from '../../../services/httpService';
import TagsMultiselector from '../../common/TagsMultiselector';
import FileUpload from '../FileUpload';
import TipsForImport from './TipsForImport';
import DefaultColumnsList from './DefaultColumnsList.js';
import {
    Button,
    Radio,
    RadioGroup,
    Tag,
    MenuItem,
    Popover,
    Menu,
    Classes,
    Position,
    Icon,
    Tooltip
} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import InfoCircle from '../../common/InfoCircle';
import countries from '../../common/countries';
import {getCurrentUserId, getJwt} from "../../../services/authService";
import axios from "axios";

const defaultColumnsList = DefaultColumnsList;

export default class ImportContacts extends Component {
    constructor() {
        super();

        this.state = {
            errorMessage: '',
            spinnerActive: false,
            dropZoneHovered: false,
            activeStep: 0,
            files: [],
            listOfObjectsForContacts: [],
            dropRejectedData: [],
            columnsList: [],
            matchedColumnsList: [],
            columnsStates: {
                matched: 0,
                unmatched: 0,
                skipped: 0
            },
            editActiveColumnIndex: '',
            defaultColumnsNames: [
                {value: 'first_name', text: 'First Name', matched: false},
                {value: 'last_name', text: 'Last Name', matched: false},
                {value: 'email', text: 'Email Address', matched: false},
                {value: 'phone', text: 'Phone Number', matched: false},
                {value: 'company', text: 'Company', matched: false},
                {value: 'gender', text: 'Gender', matched: false},
                {value: 'other_phone', text: 'Other Phone', matched: false},
                {value: 'tags', text: 'Tags', matched: false},
            ],
            subscriptionType: 'Immediate [Recommended]',
            duplicateContacts: 'Ignore the new entry and keep the existing Contacts intact.',
            selectedTags: [],
            selectedTagsIds: [],
            csvFileUrl: '',
            filteredCountries: [],
            countryCallingCode: 'Select Country Calling Code',
            tagDelimiter: ',',
            tagsFromColumns: false,
            selectCountryError: false
        };

        // Changes of defaultColumnNames should be changed in both this.state.defaultColumnsNames and in DefaultColumnsList.js
    }

    componentDidMount() {
        this.setState({filteredCountries: countries})
    }

    onFileUploadStart = () => {
        // console.log('Evo ga: ', acceptedFiles)

    };

    onFileUploadEnd = (url, file) => {
        // console.log('onFileUploadEnd: ', url, file)
        this.setState({files: [file], selectedFile: file, dropRejectedData: []})
        // this.uploadCsvFile(file)
        this.setState({
            csvFileUrl: url,
            loaded: 0,
            selectedFile: null,
            selectedFileData: null,
            spinnerActive: false
        });
        this.parseCsvFile(file);
    }

    onUploadProgressChange = () => {}

    // uploadCsvFile = (acceptedFiles) => {
    //     const reader = new FileReader();
    //     reader.addEventListener(
    //         'load',
    //         () => {
    //             this.setState({
    //                 selectedFileData: reader.result
    //             })
    //             this.fileUploadHandler(reader);
    //         },
    //         false
    //     );
    //
    //     reader.readAsDataURL(acceptedFiles[0]);
    //     this.setState({selectedFile: acceptedFiles[0]});
    // }

    // fileUploadHandler = async (fileData) => {
    //     // const upload_URL = "https://api.emitto.io/api/files/"+getCurrentUserId();
    //     if (this.state.files && this.state.files.length > 0 && fileData.result) {
    //         let file = this.state.files[0]
    //         let formData = await {
    //             file: fileData.result,
    //             category: "contacts_csv_file",
    //             name: file.name,
    //             size: file.size,
    //             type: file.type
    //         };
    //         try {
    //             await this.setState({spinnerActive: true})
    //             await http.post('api/files/' + getCurrentUserId(), formData, {headers: {authorization: getJwt()}},
    //                 {
    //                     onUploadProgress: progressEvent => {
    //                         this.setState({loaded: Math.round(progressEvent.loaded / progressEvent.total * 100)});
    //                     }
    //                 }
    //             ).then(res => {
    //                 toastr.success("CSV file successfully uploaded!");
    //                 this.setState({
    //                     csvFileUrl: res.data.contacts_csv_file,
    //                     loaded: 0,
    //                     selectedFile: null,
    //                     selectedFileData: null,
    //                     spinnerActive: false
    //                 });
    //
    //             });
    //         } catch (ex) {
    //             this.setState({spinnerActive: false})
    //             if (ex.response && ex.response.status === 404)
    //                 toastr.error("Unsuccessful upload, please try again later.");
    //             if (ex.response && ex.response.status === 401) {
    //                 toastr.error(ex.response.data.message);
    //                 this.props.history.push('/logout');
    //             }
    //         }
    //     }
    // };

    parseCsvFile = (file) => {
        const reader = new FileReader();

        // console.info('acceptedFiles: ', file)

        //reader.readAsBinaryString(acceptedFiles[0]);

        //console.log('reader.result: ', reader.result)
        reader.readAsText(file, 'UTF-8')
        reader.onload = () => {
            // console.log('reader result: ', reader.result);
            csv.parse(reader.result, (err, data) => {
                    // console.info('data: ', data)
                try{
                    let converted = this.convertToArrayOfObjects([...data])
                    // console.log(data, err);
                    // console.log('Converted: ', converted)
                    this.createColumnList(data);
                    this.createListOfObjectsForContacts(converted)
                }catch{
                    toastr.error('Error with parsing CSV file, file is not UTF-8 encoded.')
                }

                },
                {
                    // skip_empty_lines: true,
                    skip_lines_with_error: true,
                    skip_records_with_error: true,
                    relax_column_count: true,
                    // relax_column_count_more: true,
                    delimiter: [";",","],
                }
            );
        };
    }


    createColumnList = (data) => {
        //console.info('data: ', data)
        let i = data[0].length;
        let columnsList = [];
        let defaultColumnsNames = this.state.defaultColumnsNames;
        let tagsSelected = '';
        if (i > 0) {
            data[0].map((item, index) => {
                let fiveValues = [];

                for (let a = 1; a < data.length; a++) {
                    if (data[a][index]) {
                        fiveValues.push(data[a][index])
                    }
                    if (fiveValues.length === 5) {
                        break;
                    }
                }
                let matchedField = defaultColumnsList.find(column => column.name === item)

                let check = defaultColumnsList.find(column => column.name === item === 'tags');

                let isDuplicate = columnsList.find(column => matchedField && column.matchedField && (column.matchedField.databaseName === matchedField.databaseName));

                tagsSelected = check;
                columnsList.push(
                    {
                        index,
                        column: item,
                        values: fiveValues,
                        matchedField: !isDuplicate && matchedField ? matchedField : '',
                        label: matchedField ? matchedField.label : '',
                        skipped: false,
                        unmatched: matchedField && !isDuplicate ? false : true
                    }
                )
                let defaultColumnNameIndex = matchedField ? this.state.defaultColumnsNames.findIndex(column => column.text === matchedField.label) : '';
                if (matchedField) {
                    defaultColumnsNames[defaultColumnNameIndex].matched = true
                }
            })

        }
        this.setState({
            columnsList,
            defaultColumnsNames,
            tagsFromColumns: tagsSelected ? true : false
        })
        this.getColumnsStates()
    }

    convertToArrayOfObjects = (data) => {
        var keys = data.shift(),
            i = 0, k = 0,
            obj = null,
            output = [];

        let newKeys = [];
        let newKeys2 = [];
        keys.map(key => newKeys.push(key.replace(/- |-/g, "")));
        newKeys.map(key => newKeys2.push(key.replace(/\s/g, "_")));


        for (i = 0; i < data.length; i++) {
            obj = {};

            for (k = 0; k < newKeys2.length; k++) {
                obj[newKeys2[k]] = data[i][k];
            }

            output.push(obj);
        }

        return output;
    }

    createListOfObjectsForContacts = (data) => {
        this.setState({listOfObjectsForContacts: data})
    }

    updateListOfObjectsForContacts = async () => {
        let data = await this.state.listOfObjectsForContacts;
        let newData = [];
        await data.map(async (object, index) => {
            await newData.push({
                id: index,
                name: object.Name,
                // last_name: object.Family_Name,
                phone: object.Phone_1_Value,
                email: object.Email_1_Value,
                tags: this.state.selectedTags,
                subscription: this.state.subscriptionType,
                last_changes: ''
            })
        })
        await this.setState({listOfObjectsForContacts: newData})
        return newData
    }

    handleOnClickStepper = (step) => {
        this.setState({activeStep: step});
    }

    handleOnClickNext = () => {
        let nextStep = this.state.activeStep + 1;
        this.setState({activeStep: nextStep})
    }

    handleOnClickBack = () => {
        let prevStep = this.state.activeStep - 1;
        this.setState({activeStep: prevStep})
    }

    firstStep = () => {
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name} - {file.size} bytes
            </li>
        ));
        return (
            <div className="import-contacts-content-wrapper">
                <div className='import-head-wrapper'>
                    <h2>Upload contact list</h2>
                    <div className="contacts-right-links">
                        <Tooltip
                            content={<TipsForImport/>}
                            position={Position.LEFT}
                            popoverClassName='tips-for-import-tooltip'
                        >
                            <a href="#">Tips for import</a>
                        </Tooltip>
                        <a target="_blank"
                           href="https://trello-attachments.s3.amazonaws.com/5b87bca22ae6638112af1643/6001746980661e085d7a2f66/b275de4e71be7597f93fac16c5dd04c8/emitto_sample_contacts.csv">Download
                            the sample file</a>
                    </div>
                </div>
                <p className='f-14 m-lg-b'>Import contacts from .csv file or use some of the integrated service.</p>
                {this.state.files.length > 0 ?
                    this.handleUploadSuccess()
                    :
                    <FileUpload
                        category={'contacts_csv_file'}
                        maxSizeMb={25}
                        fileType='csv'
                        // disabled={this.props.documentationVerified}
                        text={'Drag and drop your file here'}
                        buttonText={'Browse files'}
                        buttonType='grey'
                        onUploadStart={this.onFileUploadStart}
                        onUploadEnd={this.onFileUploadEnd}
                        onUploadProgressChange={this.onUploadProgressChange}
                        hideLoader={false}
                        loaderSize={'large'}
                    />
                    // <Dropzone
                    //     onDrop={this.onDrop}
                    //     multiple={false}
                    //     accept={'.csv'}
                    //     maxSize={10240000}
                    //     onDragEnter={() => this.setState({dropZoneHovered: true})}
                    //     onDragLeave={() => this.setState({dropZoneHovered: false})}
                    //     onDropRejected={(e) => this.setState({dropRejectedData: e, files: []})}
                    // >
                    //     {({getRootProps, getInputProps}) => (
                    //         <section className="container">
                    //             <div {...getRootProps({className: this.state.dropZoneHovered ? 'dropzone hovered' : 'dropzone'})}>
                    //                 <input {...getInputProps()} />
                    //                 <p>Drag and drop your file here<br/><br/></p>
                    //                 <p className='small'>or <br/><br/></p>
                    //                 <span>Browse files</span>
                    //
                    //             </div>
                    //         </section>
                    //     )}
                    // </Dropzone>
                }
                <p className="light-text">
                    Please make sure that you’ve gathered <a target="_blank"
                                                             href="http://help.emitto.io/en/articles/4807698-sms-compliance">proper
                    permission</a> to send to every contact in the uploaded list,
                    as we do NOT send confirmation messages to imported contacts.
                </p>

                {this.state.dropRejectedData.length > 0 ? this.handleUploadError() : ''}

                <div className="buttons-container">
                    <button
                        className="btn-transparent-border dist-platf-button"
                        onClick={() => this.props.history.push('/contacts')}>
                        Cancel
                    </button>
                    <button
                        className={this.state.files.length > 0 ? 'btn  dist-platf-button btn-action' : 'btn  btn-transparent-border dist-platf-button'}
                        onClick={() => this.setState({activeStep: 1})}
                        disabled={this.state.files.length === 0}>
                        Next
                    </button>
                </div>
            </div>
        )
    }

    secondStep = () => {
        return (
            <div className="import-contacts-content-wrapper">
                {/*{ console.log(this.state.columnsList, this.state.defaultColumnsNames) }*/}
                <h2 style={{textAlign: 'center'}}>Map columns with fields</h2>
                <div className="flex-direction-row space-between">
                    <p style={{maxWidth: 500}}><span
                        className="green">{this.state.columnsStates.matched} matched</span> columns <span
                        className="grey">|</span>
                        <span className="red"> {this.state.columnsStates.unmatched} unmatched</span> columns <span
                            className="grey">|</span>
                        <span className="yellow"> {this.state.columnsStates.skipped} skipped</span> columns </p>
                    <p className="skipp-all-unmatched" onClick={this.skipAllUnmatchedCollumns}>Skip all unmatched
                        columns</p>
                </div>
                {this.state.columnsList.length > 0 ?
                    <div className="columns-container">
                        {this.state.columnsList.map((column, index) => {
                            return <div key={index}
                                        className={column.unmatched ? 'single-column-container unmatched' : 'single-column-container'}>
                                <div className="label-container">
                                    <h3><strong>{column.matchedField.label || column.column}</strong></h3>
                                </div>
                                {this.state.editActiveColumnIndex === column.index ?
                                    <div className='edit-container'>
                                        <Select
                                            items={[
                                                ...this.state.defaultColumnsNames,
                                                // {
                                                //     value: '',
                                                //     text: '+ Create Custom Field'
                                                // }
                                            ]}
                                            itemRenderer={(item, index) => item.matched ?
                                                <MenuItem
                                                    disabled={true}
                                                    key={index}
                                                    text={item.text}
                                                />
                                                :
                                                <MenuItem
                                                    key={index}
                                                    onClick={() => this.handleMatchField(column.index, item, index.index)}
                                                    text={item.text}
                                                />
                                            }
                                            // onItemSelect={(item, index) => this.handleMatchField(column.index, item, index.index)}
                                            filterable={false}
                                        >
                                            <Button
                                                text={column.matchedField ? column.matchedField.label : 'Please select'}
                                                rightIcon="caret-down">
                                            </Button>

                                        </Select>
                                        {this.state.tagsFromColumns && (column.matchedField.databaseName === 'tags') ?
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column'
                                            }}>
                                                <p style={{textAlign: 'center', marginBottom: 0}}>Select tags
                                                    delimiter</p>
                                                <Select
                                                    items={[',', ';', 'space', 'tab', 'new line']}
                                                    filterable={false}
                                                    itemRenderer={(item, index) => <MenuItem
                                                        key={index}
                                                        onClick={() => this.setState({tagDelimiter: item})}
                                                        text={item}
                                                    />}
                                                >
                                                    <Button
                                                        style={{width: 120, justifyContent: 'space-between'}}
                                                        text={this.state.tagDelimiter}
                                                        rightIcon="caret-down">
                                                    </Button>

                                                </Select>
                                            </div>
                                            :
                                            ''
                                        }
                                        <p className="skip-edit-links">
                                            {!column.skipped ?
                                                <span
                                                    onClick={() => this.handleSkipColumn(column.index)}>Skip </span> : ''}
                                            {!column.skipped ? ' | ' : ''}
                                            <span onClick={() => this.setState({editActiveColumnIndex: ''})}>Save</span>
                                        </p>
                                    </div>
                                    :
                                    <div className='matched-container'>
                                        {column.matchedField ? <p className="green">Matched field</p> :
                                            column.skipped ? <p className="yellow">Will not be imported</p> :
                                                column.unmatched ? <p className="red">Unmatched field</p> : ''}
                                        <p className="skip-edit-links">
                                            {!column.skipped ?
                                                <span
                                                    onClick={() => this.handleSkipColumn(column.index)}>Skip </span> : ''}
                                            {!column.skipped ? ' | ' : ''}
                                            <span
                                                onClick={() => this.setState({editActiveColumnIndex: column.index})}>Edit</span>
                                        </p>
                                    </div>
                                }
                                <div className='name-container'>
                                    <p>{column.matchedField ? column.matchedField.name : column.column}</p>
                                </div>
                                <div className='values-container'>
                                    {column.values.map((value, index) => <p key={index}>{value}</p>)}
                                </div>
                            </div>
                        })}
                    </div>
                    :
                    ''
                }
                <p className="red"
                   style={{marginTop: 20}}>{(this.state.columnsStates.unmatched > 0) || (this.state.matchedColumnsList.find(column => column.mapTo === 'phone') === undefined) ? this.state.errorMessage : ''}</p>
                <div className="buttons-container">
                    <button className="btn-transparent-border dist-platf-button"
                            onClick={() => this.setState({activeStep: 0})}>Back
                    </button>
                    <button className="btn-action dist-platf-button" onClick={() => {
                        this.state.columnsStates.unmatched > 0 ? this.setState({errorMessage: 'All the fields must be either Matched or Skipped'})
                            : (this.state.matchedColumnsList.find(column => column.mapTo === 'phone') === undefined) ?
                                this.setState({errorMessage: 'Phone field must be matched to proceed'}) : this.setState({activeStep: 2})
                    }}>Next
                    </button>
                </div>
            </div>
        )
    }

    thirdStep = () => {
        return (
            <div className="import-contacts-content-wrapper">
                <h2 style={{textAlign: 'center'}}>Organize</h2>
                <div className="organize-content-container">
                    {/*<p className="field-title">Subscription type</p>*/}
                    {/*<p className="field-explanation">Select how often will the user receive updates</p>*/}
                    {/*<Select*/}
                    {/*items={[*/}
                    {/*{*/}
                    {/*value: 'immediate',*/}
                    {/*text: 'Immediate [Recommended]'*/}
                    {/*},*/}
                    {/*{*/}
                    {/*value: 'daily',*/}
                    {/*text: 'Daily'*/}
                    {/*},*/}
                    {/*{*/}
                    {/*value: 'weekly',*/}
                    {/*text: 'Weekly'*/}
                    {/*}*/}
                    {/*]}*/}
                    {/*itemRenderer={(item, index)=> item.value === 'Immediate' ?*/}
                    {/*<MenuItem*/}
                    {/*key={index}*/}
                    {/*onClick={() => this.setState({subscriptionType: item.value})}*/}
                    {/*text={'Immediate [Recommended]'}*/}
                    {/*/>*/}
                    {/*:*/}
                    {/*<MenuItem*/}
                    {/*key={index}*/}
                    {/*onClick={() => this.setState({subscriptionType: item.value})}*/}
                    {/*text={item.text}*/}
                    {/*/>*/}
                    {/*}*/}
                    {/*filterable={false}*/}
                    {/*>*/}
                    {/*<Button*/}
                    {/*style={{width: 250, justifyContent: 'space-between'}}*/}
                    {/*text={this.state.subscriptionType }*/}
                    {/*rightIcon="caret-down">*/}
                    {/*</Button>*/}

                    {/*</Select>*/}

                    <p className="field-title">Country calling code</p>
                    <p className="field-explanation">Select country calling code</p>
                    <Select
                        items={this.state.filteredCountries}
                        itemRenderer={(item, index) => <MenuItem
                            key={index}
                            onClick={() => this.setState({
                                countryCallingCode: item.dial_code,
                                selectCountryError: false
                            })}
                            text={item.name + ' ' + item.flag}
                        />}
                        filterable={true}
                        onQueryChange={this.filterItems}
                        resetOnClose={true}
                    >
                        <Button
                            style={{
                                width: 260, justifyContent: 'space-between', border: this.state.selectCountryError ?
                                    '1px solid red' : '1px solid #D6DBDF'
                            }}
                            text={this.state.countryCallingCode}
                            rightIcon="caret-down">
                        </Button>

                    </Select>
                    {this.state.selectCountryError ?
                        <p className='red-text'>If the numbers you upload are missing the country calling code (e.g. for
                            US: +1 or 001),
                            the selected country calling code will be added to your contacts that are missing it to
                            ensure
                            international format complience and maximum deliverability.</p> : ''
                    }


                    <p className="field-title">Tags</p>
                    <p className="field-explanation">Add specific tags to all the contacts from the uploaded list.</p>
                    <div className="subscription-type-container">
                        <TagsMultiselector
                            tags={this.props.tags}
                            selectedTags={this.state.selectedTags}
                            squareType={true}
                            width={250}
                            updateTags={this.updateTags}
                            // updateTagsIds={ ()=>console.log('')}
                            handleCreateTag={this.props.handleCreateTag}
                            handleGetTags={this.props.handleGetTags}
                        />
                    </div>

                    <p className="field-title">What do you like to do with the duplicate contacts?</p>
                    <RadioGroup
                        onChange={item => this.setState({duplicateContacts: item.target.value})}
                        selectedValue={this.state.duplicateContacts}
                    >
                        <Radio label="Ignore the new entry and keep the existing Contacts intact."
                               value="Ignore the new entry and keep the existing Contacts intact."/>
                        <Radio label="Update existing entry with the new one."
                               value="Update existing entry with the new one."/>
                        {/*<Radio label="Create new entry and leave previous entry as it is." value="Create new entry and leave previous entry as it is." />*/}
                    </RadioGroup>

                </div>
                <div className="buttons-container">
                    <button
                        className="btn-transparent-border dist-platf-button"
                        onClick={() => this.setState({activeStep: 1})}
                    >
                        Back
                    </button>
                    <button
                        className={this.state.countryCallingCode === 'Select Country Calling Code' ?
                            'btn  btn-transparent-border dist-platf-button'
                            :
                            'btn  btn-action dist-platf-button'
                        }
                        onClick={() => {
                            this.state.countryCallingCode === 'Select Country Calling Code' ?
                                this.setState({selectCountryError: true})
                                :
                                this.setState({activeStep: 3})
                        }}
                        // disabled={this.state.countryCallingCode === 'Select Country Calling Code'}
                    >
                        Next
                    </button>
                </div>
            </div>
        )
    }

    fourthStep = () => {
        return (
            <div className="import-contacts-content-wrapper">
                <h2 style={{textAlign: 'center'}}>Review</h2>
                <div className="review-content-container">
                    <p className="field-title-bold">Upload</p>
                    <p className="indent-10">{this.state.files[0].name} ({(this.state.files[0].size / 1024).toFixed(2)}kb)</p>

                    <p className="field-title-bold">Matching Columns</p>
                    <div className="match-table-container">
                        <div className="table-heading">
                            <div className="heading-cell">
                                <p className="green">Matched Columns</p>
                            </div>
                            <div className="heading-cell">
                                <p className="yellow">Skipped Columns</p>
                            </div>
                        </div>
                        <div className="table-content">
                            <div className="matched-columns">
                                <ul>
                                    {this.state.columnsList.map(column => {
                                        if (column.matchedField) {
                                            return <li>{column.column} <i
                                                className="fas fa-arrow-right"/> {column.matchedField.label}
                                            </li>
                                        }
                                    })}
                                    {this.checkMissingColumns('matched')}
                                </ul>
                            </div>
                            <div className="skipped-columns">
                                <ul>
                                    {this.state.columnsList.map(column => {
                                        if (column.skipped) {
                                            return <li>{column.column}</li>
                                        }
                                    })}
                                    {this.checkMissingColumns('skipped')}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <p className="field-title-bold">Organize</p>

                    {/*<p className="field-title indent-10">Subscription type <InfoCircle infoCircleContent={*/}
                    {/*<p className='info-circle-content' >Select how often will the user receive updates</p>*/}
                    {/*}/></p>*/}
                    {/*<p className="field-title indent-20">{this.state.subscriptionType}</p>*/}

                    <p className="field-title indent-10">Tags <InfoCircle infoCircleContent={
                        <p className='info-circle-content'>All the contacts from the uploaded list will be tagged with
                            these tags.</p>
                    }/></p>
                    {this.state.selectedTags && (this.state.selectedTags.length > 0) ?
                        <div className="indent-20"> {this.state.selectedTags.map(tag => <Tag
                            style={{marginRight: 5, marginBottom: 5}}>{tag.tag}</Tag>)}</div>
                        :
                        <p className="field-title indent-20">There are no selected tags</p>
                    }
                    <p className="field-title indent-10">What to do with the duplicate contacts?</p>
                    <p className="indent-20">{this.state.duplicateContacts}</p>
                </div>
                <div className="buttons-container">
                    <button className="btn-transparent-border dist-platf-button"
                            onClick={() => this.setState({activeStep: 2})}>Back
                    </button>
                    <button onClick={this.finishImportingContacts}
                            className="btn-action dist-platf-button">Import {this.state.spinnerActive ?
                        <i className='fa fa-spin fa-spinner'></i> : ''}</button>
                </div>
            </div>
        )
    }

    checkMissingColumns = (type) => {
        let matched = this.state.columnsStates.matched;
        let skipped = this.state.columnsStates.skipped;
        let array = []

        if ((type === 'matched') && (matched < skipped)) {
            for (let i = 0; i < skipped - matched; i++) {
                array.push(i)
            }
            return array.map(item => <li style={{height: 30}}/>)
        } else if ((type === 'skipped') && (matched > skipped)) {
            for (let i = 0; i < matched - skipped; i++) {
                array.push(i)
            }
            return array.map(item => <li style={{height: 30}}/>)
        }
    }

    handleUploadError = () => {
        return (
            <div className="error-container">
                <p>
                    {
                        this.state.dropRejectedData.length > 1 ? 'You can upload only one .csv file!' :
                            this.state.dropRejectedData.type !== 'text/csv' ? 'Invalid file type! Only .csv files are supported' :
                                'File upload was unsuccessful, please try again!'
                    }
                </p>
            </div>
        )
    }

    handleUploadSuccess = () => {
        return (
            <div className="success-container">
                <h2><i className="fas fa-check"></i> File Uploaded</h2>
                <p>{this.state.files[0].name}<br/>
                    ({(this.state.files[0].size / 1024).toFixed(2)}kb )
                </p>
                <button
                    className="btn-white-border dist-platf-button"
                    onClick={() => this.setState({files: [], dropRejectedData: []})}
                >Change file
                </button>
            </div>
        )
    }

    getColumnsStates = () => {
        let columnsStates = {
            matched: 0,
            unmatched: 0,
            skipped: 0
        }
        let matchedColumnsList = []

        this.state.columnsList.map((column, index) => {
            if (column.matchedField) {
                columnsStates.matched++;
                matchedColumnsList = [
                    ...matchedColumnsList,
                    {
                        columnIndex: index,
                        columnName: column.matchedField.label,
                        mapTo: column.matchedField.databaseName
                    }
                ]
            } else if (column.skipped) {
                columnsStates.skipped++
            } else {
                columnsStates.unmatched++
            }
        })
        this.setState({columnsStates, matchedColumnsList})
    }

    handleSkipColumn = (index) => {
        let newList = this.state.columnsList;
        let newDefaultColumnsNames = this.state.defaultColumnsNames;
        let defaultColumnsNamesIndex = newDefaultColumnsNames.findIndex(column => column.value === newList[index].matchedField.databaseName)
        newList[index] = {
            ...newList[index],
            matchedField: '',
            skipped: true,
            unmatched: false
        }
        newDefaultColumnsNames[defaultColumnsNamesIndex] = {
            ...newDefaultColumnsNames[defaultColumnsNamesIndex],
            matched: ''
        }
        this.setState({
            columnsList: newList,
            defaultColumnsNames: defaultColumnsNamesIndex === -1 ? this.state.defaultColumnsNames : newDefaultColumnsNames
        })
        this.getColumnsStates()
    }

    handleMatchField = (columnsListIndex, defaultColumnNameObject, defaultColumnNameIndex) => {
        let defaultColumnsNames = this.state.defaultColumnsNames;

        let columnsList = this.state.columnsList;


        columnsList[columnsListIndex] = {
            ...columnsList[columnsListIndex],
            skipped: false,
            unmatched: false,
            matchedField: {
                databaseName: defaultColumnNameObject.value,
                label: defaultColumnNameObject.text,
                name: columnsList[columnsListIndex].column
            }
        }

        defaultColumnsNames[defaultColumnNameIndex] = {
            ...defaultColumnNameObject,
            matched: true
        }
        if (columnsList[columnsListIndex].matchedField.databaseName === 'tags') {
            this.setState({tagsFromColumns: true})
        }

        this.setState({
            columnsList,
            defaultColumnsNames
        })
        this.getColumnsStates()
    }

    updateTags = (tags) => {
        let tagsIds = Array.from(tags, tag => tag.id)
        this.setState({selectedTags: tags, selectedTagsIds: tagsIds})
        // console.log(this.state.selectedTags, this.state.selectedTagsIds)
    }

    skipAllUnmatchedCollumns = () => {
        let newList = this.state.columnsList;
        let newDefaultColumnsNames = this.state.defaultColumnsNames;

        newList.map((column, index) => column.unmatched ?
            newList[index] = {
                ...newList[index],
                matchedField: '',
                skipped: true,
                unmatched: false
            }
            :
            ''
        )

        this.setState({
            columnsList: newList
        })

        this.getColumnsStates()
    }

    finishImportingContacts = async () => {
        let subscriptionType = await this.state.subscriptionType === 'Immediate [Recommended]' ? 'immediate' : this.state.subscriptionType.toLowerCase();
        // let contacts = await this.updateListOfObjectsForContacts();
        // let contacts = await {
        //     csvFileUrl: this.state.csvFileUrl,
        //     matchedColumns: this.state.matchedColumnsList,
        //     duplicateContacts: this.state.duplicateContacts,
        //     // duplicateContacts: 'Create new entry and leave previous entry as it is.',
        //     subscriptionType: subscriptionType,
        //     tag_ids: this.state.selectedTagsIds,
        //     country_code: this.state.countryCallingCode,
        //     tags_delimiter: this.state.tagDelimiter === 'new line' ? '&#10;' : this.state.tagDelimiter === 'tab' ?
        //         '&nbsp;&nbsp;&nbsp;&nbsp;' : this.state.tagDelimiter === 'space' ? '&nbsp;' : this.state.tagDelimiter
        // }

        if (!this.state.csvFileUrl || !this.state.matchedColumnsList || this.state.matchedColumnsList.length < 1 || !this.state.countryCallingCode) {
            // console.log('import_csv error data: ', this.state.csvFileUrl, this.state.matchedColumnsList, this.state.countryCallingCode)
            toastr.error("There are some contacts data that are missing, please check and try importing again.");
        } else {
            try {
                let userId = this.props.userId;
                let selectedSource = this.props.selectedSource;
                this.setState({spinnerActive: true})

                // const contactsImportResult = process.env.REACT_APP_ENVIRONMENT === 'PROD' ?
                //     await http.post('http://emitto-live-api.us-east-1.elasticbeanstalk.com/api/user/'+ userId + '/project/' + selectedSource + '/import_csv', contacts, {headers: {authorization: getJwt()}})
                //     :
                //     await http.post('http://dev-emitto-ebs-new.us-east-1.elasticbeanstalk.com/api/user/' + userId + '/project/' + selectedSource + '/import_csv', contacts, {headers: {authorization: getJwt()}})
                const contactsImportResult = await http.post('/api/user/' + userId + '/project/' + selectedSource + '/import_csv', {
                    csvFileUrl: this.state.csvFileUrl,
                    matchedColumns: this.state.matchedColumnsList,
                    duplicateContacts: this.state.duplicateContacts,
                    // duplicateContacts: 'Create new entry and leave previous entry as it is.',
                    subscriptionType: subscriptionType,
                    tag_ids: this.state.selectedTagsIds,
                    country_code: this.state.countryCallingCode,
                    tags_delimiter: this.state.tagDelimiter === 'new line' ? '&#10;' : this.state.tagDelimiter === 'tab' ?
                        '&nbsp;&nbsp;&nbsp;&nbsp;' : this.state.tagDelimiter === 'space' ? '&nbsp;' : this.state.tagDelimiter
                }, {headers: {authorization: getJwt()}})

                // console.log('Rezultat za import contacts: ', contactsImportResult)
                this.setState({spinnerActive: false})
                this.props.history.push({
                    pathname: '/contacts',
                    state: {
                        jobId: contactsImportResult.data.job.id
                    }
                })
                // console.log('Contacts import object: ', contacts)
            } catch (e) {
                this.setState({spinnerActive: false})
                this.props.history.push('/contacts');
                toastr.success("Contacts are being imported, check in a few minutes.")
                // toastr.error("There have been some problem with importing contacts, please try again");
                // console.log('Contacts import error: ', e)
            }
        }
    }

    filterItems = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
            .map((word, i) => {
                if (i + 1 === words.length && !hasTrailingSpace) {
                    // The last word - ok with the word being "startswith"-like
                    return `(?=.*\\b${escapeRegExp(word)})`;
                } else {
                    // Not the last word - expect the whole word exactly
                    return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                }
            })
            .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        countries.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredCountries: filteredArray
        })
    };

    render() {
        let num = this.state.activeStep
        const steps = [
            {
                title: 'Upload .csv',
                icon: num > 0 ? './img/check-green.png' : ''
            },
            {
                title: 'Matching Columns',
                icon: num > 1 ? './img/check-green.png' : ''
            },
            {
                title: 'Organize',
                icon: num > 2 ? './img/check-green.png' : ''
            },
            {
                title: 'Review',
                icon: num > 3 ? './img/check-green.png' : ''
            }]


        return <React.Fragment>
            <h1 className='main-title'>Import Contacts</h1>
            <p className="nav-back" onClick={() => this.props.history.push('/contacts')}><i
                className="fas fa-chevron-left"></i> Contacts</p>
            <div className="stepper-container">
                <Stepper
                    steps={steps}
                    activeStep={this.state.activeStep}
                    onSelect={this.handleOnClickStepper}
                    showNumber={true}
                    lineMarginOffset={2}
                    circleFontColor={'$grey-border'}
                    defaultColor={'white'}
                    defaultBorderStyle={'solid'}
                    defaultBorderWidth={1}
                    defaultBorderColor={'#D6DBDF'}
                    completeColor={'#DBF2EF'}
                    completeBorderColor={'#17AA94'}
                    completeBorderStyle={'solid'}
                    completeBarColor={'#17AA94 !important'}
                    activeColor={'#E7F6FC'}

                    activeBorderStyle={'solid'}
                    activeBorderColor={'#18A9E3'}
                />
            </div>
            {
                this.state.activeStep === 0 ?
                    this.firstStep() :
                    this.state.activeStep === 1 ?
                        this.secondStep() :
                        this.state.activeStep === 2 ?
                            this.thirdStep() : this.fourthStep()
            }
            {/*{console.log(this.state.columnsList)}*/}
        </React.Fragment>
    }
}

